const PARENT_SELECTOR = '.option-group'
const CHILD_SELECTOR = '.option'
const EVENT_NAME = 'option-group:change'

const initialize = (element) => {
  if (element.dataset.optionGroupInitialized) return false;

  element.querySelectorAll(CHILD_SELECTOR).forEach((option) => {
    option.addEventListener('click', (event) => {
      activate(element, event.currentTarget)
    })
  })

  element.dataset.optionGroupInitialized = true
}

const activate = (group, option) => {
  const previous = group.querySelector('.active')

  if (option === previous) return

  if (previous) {
    previous.classList.remove('active')
  }

  option.classList.add('active')
  dispatchChangeEvent(group, option, previous)
}

const dispatchChangeEvent = (group, active, previous) => {
  group.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      bubbles: true,
      detail: {
        group: group,
        active: active,
        previous: previous
      }
    })
  );
}

const attachAll = () => {
  document.querySelectorAll(PARENT_SELECTOR).forEach(initialize)

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      mutation.target.querySelectorAll(PARENT_SELECTOR).forEach(initialize)
    })
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

export default { attachAll }
